import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import TopBar from "./TopBar";
import { connect } from "react-redux";
import actions from "src/duck/global/actions";
// import { useCookies } from "react-cookie";
import { apiEndpoints, apiGetRequest, apiPostRequest } from "src/utils/api/api";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    height: "100%",
    width: "100%",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    paddingTop: 64,
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "auto",
  },
  img: {
    margin: "auto",
    display: "block",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "42%",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "52%",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95%",
    },
    maxHeight: "100%",
  },
}));

const MainLayout = ({
  globalData,
  setAuthorized,
  setSystemInfo,
  setCalendarEventsCount,
}) => {
  const classes = useStyles();

  const navigate = useNavigate();
  // const [removeCookie] = useCookies(["JwtToken"]);

  useEffect(() => {
    if (globalData.currentUser.logout) {
      // removeCookie("JwtToken");
      apiPostRequest(apiEndpoints.logout.path, {"username":globalData.currentUser.currentUserData.username}, true)
        .then((data) => {
          setAuthorized(false);
          navigate("/logowanie");
        })
        .catch((error) => {});
    }
    apiGetRequest(apiEndpoints.getSystemInfo.path, true)
      .then((data) => {
        setSystemInfo(data);
      })
      .catch((error) => {});
    apiGetRequest(apiEndpoints.getCalendarInfo.path, true)
      .then((data) => {
        setCalendarEventsCount(data.count);
      })
      .catch((error) => {});
  }, [globalData.currentUser.logout]);

  return (
    <div className={classes.root}>
      <TopBar
        loaderOn={globalData.globalLoader}
        systemInfo={globalData ? globalData.systemInfo : null}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content} tabIndex="-1">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  setAuthorized: (isAuthorized) =>
    dispatch(actions.setAuthorized(isAuthorized)),
  setSystemInfo: (systemInfo) => dispatch(actions.setSystemInfo(systemInfo)),
  setCalendarEventsCount: (calendarEventsCount) =>
    dispatch(actions.setCalendarEventsCount(calendarEventsCount)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
